import { Flex } from 'rebass';
import React from 'react';
import styled, { keyframes } from 'styled-components';

const slideLeft = keyframes`
  0% {
    opacity: 0;
    transform: translate3d(48px, 0px, 0px);
  };
  100% {
    opacity: 1;
    transform: translate3d(0px, 0px, 0px);
  };
`;

const Wrap = styled(Flex)`
  opacity: 0;
  animation: 500ms ease-out 50ms 1 normal forwards running ${slideLeft};
  display: flex;
  flex-direction: column;
  -webkit-box-pack: start;
  justify-content: flex-start;
  flex: 1;
`;

export const ComponentWrap = ({ children }) => {
  return <Wrap pt={4}>{children}</Wrap>;
};
